// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"323":"3456a79149cda1f9","613":"78cefb1d13de4b5d"}[chunkId] + ".js";
};